<div class="px-8 flex" [ngClass]="variantClass">
  <div class="flex w-full header-wrapper">
    <header class="py-4">
      <ng-container *ngIf="label; then labelTemplate; else contentTemplate"></ng-container>
    </header>

    <div class="ml-auto">
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-template #contentTemplate>
  <ng-content select="[heading]"></ng-content>
</ng-template>
<ng-template #labelTemplate>
  <label class="h4" [attr.for]="labelFor">
    {{ label }}
  </label>
</ng-template>
